import React from 'react';
import { AlertCircle } from 'lucide-react';
import { Button } from '../../components/ui/Button';
import type { RecoverableSession } from '../utils/assessmentSessionRecovery';
import { useFocusTrap } from '../../app/hooks/useFocusTrap';
import { useEscapeKey } from '../../app/hooks/useEscapeKey';
interface AssessmentRecoveryModalProps {
  session: RecoverableSession;
  onResume: () => void;
  onAbandon: () => void;
}
export function AssessmentRecoveryModal({
  session,
  onResume,
  onAbandon
}: AssessmentRecoveryModalProps) {
  const focusTrapRef = useFocusTrap(true);
  useEscapeKey(onAbandon);
  return <>
      <div className="fixed inset-0 bg-slate-900/40 backdrop-blur-sm z-40" data-id="element-868" data-mp="1wiokja5nsllo" />
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-869" data-mp="1rk3kpbubk3xr">
        <div ref={focusTrapRef} className="bg-white rounded-2xl shadow-xl max-w-md w-full p-6 space-y-4" role="dialog" aria-modal="true" aria-labelledby="recovery-title" data-id="element-870" data-mp="25kecqi7d7oki">
          
          <div className="flex items-center gap-3" data-id="element-871" data-mp="20jgts3ej6qhy">
            <div className="flex-shrink-0 w-10 h-10 rounded-full bg-amber-100 flex items-center justify-center" data-id="element-872" data-mp="s38qszv5d5uj">
              <AlertCircle className="h-5 w-5 text-amber-600" data-id="element-873" data-mp="x1sfh814kvql" />
            </div>
            <div data-id="element-874" data-mp="11zbrs2e9iyfw">
              <h2 id="recovery-title" className="text-lg font-bold text-gray-900" data-id="element-875" data-mp="11ysa8msiyc2e">
                
                Toets hervatten?
              </h2>
              <p className="text-sm text-gray-500" data-id="element-876" data-mp="1b1b8supa22iu">
                Er is een onafgemaakte toets gevonden
              </p>
            </div>
          </div>

          <div className="bg-gray-50 rounded-lg p-3 space-y-1" data-id="element-877" data-mp="1fybidflc5nep">
            <p className="text-sm text-gray-700" data-id="element-878" data-mp="1kql5knv2g9da">
              <strong data-id="element-879" data-mp="1kt798ceu64q8">{session.attempt.answers.length}</strong> van{' '}
              <strong data-id="element-880" data-mp="1ppejghe9m2dz">{session.blueprint.questions.length}</strong> vragen
              beantwoord
            </p>
            <p className="text-xs text-gray-500" data-id="element-881" data-mp="1uqve3v65osm4">
              Opgeslagen {Math.round((Date.now() - session.savedAt) / 60000)}{' '}
              minuten geleden
            </p>
          </div>

          <div className="flex gap-3" data-id="element-882" data-mp="3vri5wct7wfsj">
            <Button variant="secondary" onClick={onAbandon} className="flex-1" data-id="element-883" data-mp="3qsfdpsyc641z">
              Opnieuw beginnen
            </Button>
            <Button variant="primary" onClick={onResume} className="flex-1" data-id="element-884" data-mp="8f7ok0obp836">
              Hervatten
            </Button>
          </div>
        </div>
      </div>
    </>;
}